import React from 'react'
import Timeline from '../../../../components_new/Timeline'
import { TimelineProps } from '../../../../components_new/timelineProps'
import { SCENE_HEIGHT } from '../../../../components_new/utils/layout'
import { ActivityInfo } from '@/modules/drivers/types/activities'
import moment from 'moment'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { LoaderIcon } from '@/app/features/icons/Loader'

const CalendarDayInfoChart = ({
  isLoading,
  currentDate,
  activities,
  startTime,
}: {
  isLoading: boolean
  currentDate: string
  activities: ActivityInfo
  startTime: string
}) => {
  const chartWidth = 1000
  const { t } = useLocalize()
  const hasActivities =
    activities && !Array.isArray(activities) && activities.activities
  const MEANINGFUL_TYPES = new Set([1, 2, 3])
  const hasMeaningfulActivities =
    hasActivities &&
    (activities.activities as any[]).some((a) => MEANINGFUL_TYPES.has(a.type))
  return (
    <div className="tw-relative tw-min-h-[130px] tw-w-full tw-overflow-x-auto tw-overflow-y-hidden tw-bg-[#F3F3F3]">
      {isLoading && (
        <div className="tw-absolute tw-inset-0 tw-z-[999] tw-grid tw-place-items-center tw-bg-black/30">
          <LoaderIcon className="tw-animate-spin" />
        </div>
      )}
      {hasMeaningfulActivities && (
        <Timeline
          {...({
            startTime: moment(startTime),
            days: 1,
            width: chartWidth,
            height: SCENE_HEIGHT,
            extraCurrentDate: currentDate,
            translate: t,
            activities: activities.activities,
            cardInserts: activities.cardInserts || [],
            places: activities.places || [],
            dayActivities: activities.dayActivities || [],
            violations: activities.violations || [],
            dailyRests: activities.dailyRests || [],
            dailyPartialRegularRests: activities.dailyPartialRegularRests || [],
            weeklyRests: activities.weeklyRests || [],
            weeklyReducedRests: activities.weeklyReducedRests || [],
            breaks: activities.breaks || [],
            partialBreaks: activities.partialBreaks || [],
            weekRecompenses: activities.weekRecompenses || [],
            outOfScopes: activities.outOfScopes || [],
            existingDelegations: [],
            changeAreas: [],
            tmsData: [],
            minimalPaymentCountries: [],
            periodSelections: [],
            delegationMarkers: [],
            allEvents: [],
            allTripEvents: [],
            allPreviousTripEvents: [],
            countries: [],
            selectedActivity: null,
            editedActivity: null,
            isAddingNew: false,
            simpleMode: true,
            editMode: false,
            disableTooltips: false,
            showViolations: false,
            showDelegations: false,
            canEdit: false,
            canGenerateAttestation: false,
            onSelected: () => {},
            onContextMenuChanged: () => {},
            onAdd: () => {},
            onEdit: () => {},
            onViolationSelected: () => {},
            onPeriodSelectionsChanged: () => {},
          } as unknown as TimelineProps)}
        />
      )}
    </div>
  )
}

export default CalendarDayInfoChart
